import { Card as BootstrapCard, Modal } from 'react-bootstrap';
import { Link as Router } from 'react-router-dom';
import styled from 'styled-components';
import { Form } from 'formik';
import { ReactComponent as EditIc } from '~/assets/icons/form-edit.svg';
import { ReactComponent as SubjectIc } from '~/assets/icons/subject.svg';

export const EditIcon = styled(EditIc)`
  margin-top: 3px;
`;

export const FormContainer = styled(Form)``;

export const Error = styled.span`
  color: #dc3545;
`;

export const SubjectIcon = styled(SubjectIc)`
  height: 22px;
  width: 22px;
  margin-right: 4px;
  align-self: center;
`;

export const Container = styled.div`
  width: 100%;
  padding: 0 20px 0 20px;
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
  height: 84vh;
  @media (max-width: 1100px) {
    height: 90vh;
  }
  @media (max-width: 440px) {
    height: 100%;
  }
`;

export const MenuOptions = styled(Router)`
  text-decoration: none !important;
`;

export const OptionsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  text-decoration: none !important;
`;

export const Link = styled.a`
  color: #808495 !important;
  text-decoration: none !important;
`;

export const Card = styled(BootstrapCard)`
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : 0)};
`;

export const CardBody = styled(Card.Body)`
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
  padding-bottom: 2em;
  width: 175px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

export const OptionText = styled.span`
  font-size: 1.25rem;
  text-align: center;
`;

export const OptionIcon = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.span`
  font-size: 3rem;
  color: #074f8c;
`;

export const OptionTitle = styled.span`
  text-decoration: none !important;
`;

export const Space = styled.div`
  margin-left: 4em;
`;

export const ResponsiveMenu = styled.div`
  overflow: hidden;
  @media (max-width: 1099px) {
    display: none;
  }
`;

export const PageTitle = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  margin-top: 1.5rem;
  margin-bottom: 21px;
  font-size: 1.5rem;
  padding-bottom: 15px;
  border-bottom: 1px dashed ${({ theme }) => theme.colors.lightGray};
  font-weight: bold;
`;

export const FieldName = styled.span`
  color: ${({ theme }) => theme.colors.mediumGray};
  position: absolute;
  padding-top: 2px;
  margin-left: 30px;
  transition: font-size 1s;
  transform: translateY(-3px);
  font-size: 0.625rem;
`;

export const Input = styled.div`
  position: relative;
  display: flex;
  background: white;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: 100%;
  color: ${({ theme }) => theme.colors.gray};
  padding: 8px 12px 8px 12px;
  height: 50px;

  &:focus-within {
    border: 1px solid ${({ theme }) => theme.colors.lightBlue};
  }

  &:focus-within ${SubjectIcon} {
    .b {
      fill: ${({ theme }) => theme.colors.lightBlue};
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px 10px 10px;
  margin-bottom: -25px;
  @media (max-width: 1000px) {
    width: 100%;
    justify-content: center;
  }
`;

export const SendButton = styled.button`
  width: 300px;
  height: 50px;
  font-size: 1.1875rem;
  background-color: ${(props) =>
    props.disabled ? '#808495' : props.theme.colors.blue};
  color: #ffffff;
  font-weight: bold;
  border-radius: 0.5rem;
  outline-style: none;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: 0.5s opacity;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.85;
    background-color: ${(props) =>
      props.disabled ? '#808495' : props.theme.colors.blue};
    color: #ffffff;
  }
  &:focus {
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active {
    background-color: ${(props) =>
      props.disabled ? '#808495' : props.theme.colors.blue};
    opacity: 0.85;
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active:focus {
    background-color: ${(props) =>
      props.disabled ? '#808495' : props.theme.colors.blue};
    opacity: 0.85;
    box-shadow: none;
  }
`;

export const ButtonText = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
`;

export const Loading = styled.i`
  font-size: 1.25rem;
`;

export const Select = styled.select`
  display: flex;
  width: 100%;
  flex: 1;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.gray};
  outline: none !important;
  padding: 0;
  margin-top: 10px;

  .placeholder {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

export const Option = styled.option``;

export const Hr = styled.hr`
  border: 0px;
`;

export const Br = styled.br``;

export const ShortcutContainer = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShortcutLink = styled(Router)`
  text-decoration: none !important;
  margin-right: 20px;
`;

export const Shortcut = styled(Card)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 0;
  border-radius: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: ${(props) => (props.selected ? '#074f8c' : '#ffffff')};
  cursor: ${(props) => (props.selected ? 'default' : 'pointer')};
  width: 130px;
  height: 115px;
  transition: 0.5s color;
  @media (max-width: 1150px) {
    margin-top: -2px;
    width: 120px;
    height: 105px;
  }
  @media (max-width: 440px) {
    width: 90px;
    height: 75px;
  }
  @media (max-width: 350px) {
    width: 80px;
    height: 65px;
  }
`;

export const ShortcutIcon = styled.span`
  color: ${(props) => (props.selected ? '#ffffff' : '#074f8c')};
  font-size: 1.8em;
  margin-top: -8px;
  @media (max-width: 440px) {
    font-size: 1.4em;
  }
  @media (max-width: 350px) {
    font-size: 1.3em;
  }
`;

export const ShortcutText = styled.span`
  color: ${(props) => (props.selected ? '#ffffff' : '#808495')};
  text-align: center;
  font-size: 0.9em;
  @media (max-width: 440px) {
    font-size: 0.7em;
  }
  @media (max-width: 350px) {
    font-size: 0.6em;
  }
`;

export const Scrollbar = styled.div`
  ::-webkit-scrollbar-track {
    background-color: #f1f9ff;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #f1f9ff;
  }
  ::-webkit-scrollbar-thumb {
    background: #f1f9ff;
  }
  height: 82vh;
  @media (max-width: 1100px) {
    height: 90vh;
  }
  @media (max-width: 440px) {
    height: 80vh;
  }
`;

export const FieldIcon = styled.span`
  font-size: 22px;
  color: #c1c1c1;
  margin-right: 8px;
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: auto;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 28px 28px;
  max-width: 670px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;

  div {
    display: flex;
    place-content: space-between;
    align-items: center;
    h2 {
      margin: 0;
      color: #808495;
      font-size: 18px;
      font-weight: 400;
    }
  }

  svg {
    flex-shrink: 0;

    &:first-child {
      margin-right: 10px;
    }

    &:last-child {
      color: ${({ theme }) => theme.colors.darkBlue};
      cursor: pointer;
      margin-left: 10px;
    }
  }

  margin-bottom: 16px;
`;

export const TitleHome = styled.h1`
  color: #000eff;
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 15px;
`;

export const SubTitleHome = styled.h2`
  color: #7a7a7a;
  font-size: 1rem;
`;

export const HomeContainer = styled.div`
  margin-top: 48px;
  display: flex;
  @media (max-width: 600px) {
    padding-bottom: 16px;
    overflow: scroll;
  }
`;

export const BoxLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 172px;
  height: 158px;
  border: 1px solid #959595;
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
  justify-content: flex-start;

  & + div {
    margin-left: 16px;
  }
`;

export const BoxIconContainer = styled.div``;

export const BoxTextContainer = styled.span``;

export const BoxSeparator = styled.div`
  width: 80px;
  margin: 14px 0;
  border-bottom: 1px dashed rgb(193, 193, 193);
`;

export const BackComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  color: #000eff;
  font-weight: bold;

  span {
    margin-left: 8px;
  }
`;

export const ButtonBack = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  border-radius: 5px;
  height: 50px;
  font-size: 0.9375rem;
  font-weight: bold;
  position: relative;
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  transition: background-color 0.5s ease 0s, border-color 0.5s ease 0s,
    color 0.5s ease 0s;
  border: 2px solid rgb(0, 0, 255);
  color: rgb(0, 0, 255);
  background-color: rgb(255, 255, 255);

  max-width: 300px;
  width: 100%;

  &:hover {
    opacity: 1;
    background-color: rgb(0, 0, 255);
    color: rgb(255, 255, 255);
  }
`;
